import { createReducer } from '@reduxjs/toolkit';
import {
  CLEAR_SHOPS,
  CLEAR_SHOP_ACCOUNTS,
  GET_SHOPS,
  GET_SHOP_ACCOUNTS,
  SET_SHOPS_LOADING,
} from '../actions/shops';
import { UsageType } from '../constants/usageType';
import { components } from '../schema/docs/api/admin';

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination: {
    current: number;
    per_page: number;
  };
};

type PrivateMoney = components['schemas']['PrivateMoney'];
type Organization = components['schemas']['Organization'];

export type Account = {
  can_transfer_topup: boolean;
  id: string;
  is_suspended: boolean;
  name: string;
  private_money: PrivateMoney;
  status: string;
};

export type Shop = {
  accounts: Account[];
  address: string;
  email: string;
  external_id: string;
  id: string;
  is_head_office: boolean;
  name: string;
  organization: Organization;
  postal_code: string;
  status: string;
  tel: string;
  shop_name_furigana?: string;
  contact_person_name?: string;
  contact_person_name_furigana?: string;
  usage_type?: UsageType | null;
};

type ShopAccount = unknown;

export type ShopState = {
  shops: Paginated<Shop>;
  shop_accounts: ShopAccount[];
  isLoading: boolean;
};

const initState: ShopState = {
  shops: { rows: [], count: 0, pagination: { current: 1, per_page: 30 } },
  shop_accounts: [], // TODO: pagination style?
  isLoading: false,
};

const shopsReducer = createReducer(initState, (builder) =>
  builder
    .addCase(GET_SHOPS, (state, action) => {
      return { ...state, shops: action.payload, isLoading: false };
    })
    .addCase(CLEAR_SHOPS, (state) => {
      return { ...state, shops: initState.shops };
    })
    .addCase(GET_SHOP_ACCOUNTS, (state, action) => {
      return { ...state, shop_accounts: action.payload };
    })
    .addCase(CLEAR_SHOP_ACCOUNTS, (state, action) => {
      return { ...state, shop_accounts: initState.shop_accounts };
    })
    .addCase(SET_SHOPS_LOADING, (state) => {
      return { ...state, isLoading: true };
    })
);

export default shopsReducer;
